import React from 'react';
import OptimizedDashboard from './OptimizedDashboard';

const Dashboard: React.FC = () => {
  return <OptimizedDashboard />;
};

export default Dashboard; 